import React, { useContext } from 'react'
import { Context } from '@/components/Context'
import { ArtData } from '@/database/art'
import { uni1d800 } from '@/utils/extras'
import Box from '@/components/boxes/Box'

const calcTotalNfts = (portfolioDataArray: ArtData[], currentAccount: string): string => {
    const totalNfts = portfolioDataArray.reduce((total: number, artData) => {
        if (artData.art.nft && artData.art.currentOwner === currentAccount) {
            total += 1
        }
        return total
    }, 0)
    return totalNfts === 0 ? '-' : totalNfts.toString()
}

const handleClick = (hash: string) => {
    window.location.hash = hash
}

const HeaderTokens = () => {
    const { votePower, totalClaimPower, currentAccount, tokenAmount, portfolioData } = useContext(Context)

    return (
        <div>
            <div className={'header-container'}>
                <div className="nav__balances menu-wrapper-column bottom">
                    <div className="react-flow-image__shadow_blue">
                        <div className="padding-five react-flow__shadow_red">
                            <div onClick={() => handleClick('#dex')}>
                                <Box
                                    caption={'Your Token -   \uD836\uDE17CRAZY\u200C\uD836\uDE17'}
                                    styleCaption={uni1d800.className + ' center small'}
                                    styleText={'center'}
                                    text={
                                        <span className="nav__token-amount">
                                            <span className={uni1d800.className + ' white margin-right'}>
                                                \uD836\uDE17
                                            </span>
                                            {tokenAmount}
                                        </span>
                                    }
                                    textValue={tokenAmount}
                                />
                            </div>
                            <div onClick={() => handleClick('#mint')}>
                                <Box
                                    caption={'Vote Power'}
                                    styleCaption={'center small'}
                                    styleText={'center'}
                                    text={votePower}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nav__balances_end bottom">
                    <div className="react-flow-image__shadow_blue">
                        <div className="padding-five react-flow__shadow_red">
                            <div onClick={() => handleClick('#portfolio')}>
                                <Box
                                    caption={"CRAZY NFT's"}
                                    styleCaption={'center small'}
                                    styleText={'center'}
                                    text={calcTotalNfts(portfolioData, currentAccount ?? '')}
                                />
                            </div>
                            <div onClick={() => handleClick('#market')}>
                                <Box
                                    caption={'Claim Power'}
                                    styleCaption={'center small'}
                                    styleText={'center'}
                                    text={totalClaimPower}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeaderTokens
